// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wb_a bhh_b bhh_wb"};